import Done from "@mui/icons-material/Done";
import React, { useState } from "react";
import { userActivityLogger } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { PAGES_PATH } from "../../navigation/params";

interface InputWithCopyProps {
    value: string;
    label: string;
    referralCode?: string
}
const InputWithCopy = ({ value, label, referralCode }: InputWithCopyProps) => {
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(value);
    setIsLinkCopied(true);
    setTimeout(() => {
      setIsLinkCopied(false);
    }, 1500);
    const isFromReferralPage = window.location.href.includes(PAGES_PATH.REFER_FRIEND);

    userActivityLogger(MIXPANEL_EVENTS.REFERRAL_MODAL_COPY_LINK, {
      referral_code: referralCode,
      referral_link: value,
      source: isFromReferralPage?"referral_landing_page":"upsell",
      user_session_type: "logged_in",
    });
  };

  return (
    <div>
      <label className="text-xs font-semibold block mb-1">{label}</label>
      <div className="flex justify-between rounded-lg shadow-sm border-2
                 border-taupe-15 p-2">
        <input
          type="text"
          value={value}
          readOnly
          className="w-9/12 sm:w-5/6
                  rounded-l-md text-sm py-2 focus:outline-none text-gv-gold truncate"
        />
        <button
          className="bg-gv-yellow
                 hover:bg-black hover:text-white
                  text-black text-sm font-semibold px-4 py-2 rounded-full transition-colors"
          onClick={handleCopyLink}
        >
          {isLinkCopied ? <span className="flex items-center"><Done fontSize="small" />&nbsp;Copied</span> : "Copy"}
        </button>
      </div>
    </div>
  );
};

export default InputWithCopy;
